<template>
    <div class="login-wrap">
        <div class="ms-login">
            <div class="ms-title">后台管理系统</div>
            <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="username">
                    <el-input v-model="param.username" placeholder="username">
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        type="password"
                        placeholder="password"
                        v-model="param.password"
                        @keyup.enter.native="submitForm()"
                    >
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm()">登录</el-button>
                </div>
                <p class="login-tips">Tips : 用户名和密码随便填。</p>
            </el-form>
        </div>
    </div>
</template>

<script>
import {post,get} from '../../api/request.js'
import {setCookie, getCookie, delCookie} from '../../api/cookie.js'
export default {
    data: function() {
        return {
            param: {
                username: '',
                password: '',
            },
            rules: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
            },
        };
    },
    methods: {
        submitForm() {
            let formdata = new FormData()
            formdata.append('username',this.param.username)
            formdata.append('password',this.param.password)
            post('admin/login/login',formdata).then(res=>{
                if (res.data.msg == '密码错误')
                    this.$message.error("密码错误")
                else if (res.data.msg =='不存在该用户')
                    this.$message.error("不存在该用户")
                else{
                    sessionStorage.setItem('ms_username', this.param.username);
                    setCookie('UserName',this.param.username);
                    sessionStorage.setItem('userid',res.data.data.id)
                    this.$store.commit('setRoleId', res.data.data.role)
                    sessionStorage.setItem('roleid',res.data.data.role)
                    if(res.data.data.role ==1 ||res.data.data.role == 2 )
                         this.$router.push('dashboard')
                    else if(res.data.data.role == 3 ){
                        var objname = "id=" + res.data.data.id +"&companyname=" +res.data.data.company;
                        this.$router.push('dashboardNext?'+objname)
                    }
                    else if(res.data.data.role == 4){
                        var objname = "id=" + res.data.data.company_id +"&companyname=" +res.data.data.company;
                        this.$router.push('dashboardNext?'+objname)
                    }
                    else if(res.data.data.role == 5  
                    ){
                        var objname = "id=" + res.data.data.company_id +"&companyname=" +res.data.data.company;
                        this.$router.push('dashboardNext?'+objname)
                    }
                      
                    }
            })
          
        },
    },
};
</script>

<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/img/login-bg.jpg);
    background-size: 100%;
}
.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    border-bottom: 1px solid #ddd;
}
.ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}
.ms-content {
    padding: 30px 30px;
}
.login-btn {
    text-align: center;
}
.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}
.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}
</style>